module.exports = __webpack_public_path__ + "img/intestine.cd6ddb7c.png";